import * as React from 'react';

import { getTimezoneOffsetMS } from './timeslot-utils';

export const CurrentTimeContext = React.createContext();

// Update the time for use in Time Slot selection every minute or so
const useCurrentTime = () => {
  const [time, setTime] = React.useState();
  const [timezoneOffsetMS, setTimezoneOffsetMS] = React.useState();

  // Determine time zone offset and set initial time MS
  React.useEffect(() => {
    if (!timezoneOffsetMS) {
      // 'America/New_York', 'Etc/GMT' TODO: Pull zone from dispensary
      const offsetMS = getTimezoneOffsetMS(new Date(), 'America/New_York');
      setTimezoneOffsetMS(offsetMS);
      setTime(new Date().getTime() + offsetMS);
    }
  }, [timezoneOffsetMS]);

  /**
   * For testing
   *   if (tweaked) {
   *     setTime(new Date().getTime());
   *   } else {
   *     setTime(new Date("Nov 3, 2021 03:44:55").getTime());
   *     console.log(`tweak: ${new Date("Nov 3, 2021 03:44:55").toLocaleTimeString()}`); 
   *     setTweaked(true);
   *   }
   */
  
  // Update current time every 10s
  React.useEffect(() => {
    let interval;
    if (typeof timezoneOffsetMS === 'number') {
      interval = window.setInterval(() => {
        setTime(new Date().getTime() + timezoneOffsetMS);
      }, 10000);
    }
    return () => window.clearInterval(interval);
  }, [time, timezoneOffsetMS]);
  return time;   
};

const CurrentTimeProvider = ({children}) => {
  const currentTimeMS = useCurrentTime();
  return <CurrentTimeContext.Provider value={currentTimeMS}>
    {children}
  </CurrentTimeContext.Provider>
}

export default CurrentTimeProvider;
